import component from './UiIcon.vue'
export default component
